import React from 'react';
import { Icon, Label, SemanticCOLORS } from 'semantic-ui-react';

import { RecipientAttemptSummaryDTO } from '../../../services/standalone-charges';
import { formatDateTime } from '../utils/activationDetailsHelpers';

type Props = {
  attempts: RecipientAttemptSummaryDTO[];
};

const outcomeLabelMap: Record<string, string> = {
  pending: 'Em andamento',
  active: 'Aprovada',
  biometry_rejected: 'Recusada',
  registration_rejected: 'Cadastro recusado',
  superseded: 'Substituída'
};

const outcomeColorMap: Record<string, SemanticCOLORS> = {
  pending: 'yellow',
  active: 'green',
  biometry_rejected: 'red',
  registration_rejected: 'red',
  superseded: 'grey'
};

const truncateRecipientId = (id: string): string => {
  if (id.length <= 12) return id;
  return `${id.slice(0, 8)}…${id.slice(-4)}`;
};

const RecipientAttemptsTimeline: React.FC<Props> = ({ attempts }) => {
  if (!attempts.length) {
    return (
      <p style={{ margin: 0, color: '#767676' }}>Nenhuma tentativa registrada ainda.</p>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {attempts.map(attempt => (
        <div
          key={attempt.id}
          style={{
            borderLeft: '3px solid #ddd',
            paddingLeft: 12
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <strong>Tentativa {attempt.attemptNumber}</strong>
            <Label
              size="tiny"
              color={outcomeColorMap[attempt.outcome] || 'grey'}
            >
              {outcomeLabelMap[attempt.outcome] || attempt.outcome}
            </Label>
            {attempt.pagarmeStatus && (
              <Label size="tiny" basic>
                Pagarme: {attempt.pagarmeStatus}
              </Label>
            )}
          </div>
          <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>
            <Icon name="clock outline" />
            {formatDateTime(attempt.createdAt)}
            {attempt.pagarmeRecipientId && (
              <>
                {' '}
                · ID {truncateRecipientId(attempt.pagarmeRecipientId)}
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecipientAttemptsTimeline;
